import { type FC } from 'react';
import cn from 'classnames';
import { motion, type Variants } from 'framer-motion';

import {
  type ContractDataItems,
  type ContractType,
} from '@/common/types/contract';
import { type GoodsType } from '@/common/types/goods';
import { type PlantTypeText } from '@/common/types/plant';
import { type ResourceTypeText } from '@/common/types/resource';
import { ContractClause } from '@/components/Home/Contracts/ContractClause/ContractClause';
import { FrontCardView } from '@/components/ui/FrontCardView/FrontCardView';

interface ContractCardProps {
  index: number;
  isOpen: boolean;
  item: ResourceTypeText | PlantTypeText | GoodsType;
  isHorizontal: boolean;
  value: ContractDataItems;
  contractType?: ContractType;
  inModal?: boolean;
  className?: string;
}

const ContractCard: FC<ContractCardProps> = ({
  index,
  isOpen,
  item,
  isHorizontal,
  contractType,
  inModal,
  value,
  className,
}) => {
  const transition = (index: number) =>
    ({
      delay: index * 0.2,
      ease: 'easeOut',
      duration: 0.6,
    }) as const;

  const variants: Variants = {
    rotate: (index) => ({
      rotateY: isOpen ? 180 : 0,
      transition: transition(index),
    }),
    hide: (index) => ({
      opacity: isOpen ? 0 : 1,
      transition: transition(index),
    }),
    show: (index) => ({
      opacity: isOpen ? 1 : 0,
      transition: transition(index),
    }),
  };

  return (
    <motion.div
      custom={index}
      variants={variants}
      className={cn('flex flex-1 relative', className)}
      animate="rotate"
      initial={{ rotateY: isOpen ? 180 : 0 }}
    >
      <FrontCardView
        custom={index}
        variants={variants}
        initial={{ opacity: isOpen ? 0 : 1 }}
        animate={'hide'}
        className="absolute z-[1] inset-0"
      />
      {/* <motion.div
        custom={index}
        variants={variants}
        className={css.unknownBlock}
        initial={{ opacity: isOpen ? 0 : 1 }}
        animate={'hide'}
      >
        <span className="font-extrabold text-[2.5rem] text-white/40 leading-none">
          ?
        </span>
      </motion.div> */}
      <motion.div
        custom={index}
        variants={variants}
        className={cn(
          'absolute inset-0 flex opacity-0 -scale-x-100',
          isOpen ? 'z-[2]' : '-z-[1]',
        )}
        animate={'show'}
        initial={{ opacity: isOpen ? 1 : 0 }}
      >
        <ContractClause
          isHorizontal={isHorizontal}
          key={item}
          item={item}
          type={contractType}
          requirement={value}
          inModal={inModal}
        />
      </motion.div>
    </motion.div>
  );
};

export { ContractCard };
